module.exports = __webpack_public_path__ + "img/5x5-red-dot-grid.dbab72fb.svg";